import { render } from "./CommunityMetrics.vue?vue&type=template&id=33a5c502&scoped=true"
import script from "./CommunityMetrics.vue?vue&type=script&lang=js"
export * from "./CommunityMetrics.vue?vue&type=script&lang=js"

import "./CommunityMetrics.vue?vue&type=style&index=0&id=33a5c502&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a5c502"]])

export default __exports__